// Public product pages for the identifiers the listing forms show. Same URLs
// as the grid buttons (ListingTableButtonsPanel) and the supplier store
// drawer (SupplierStoreDrawer) open.

export function amazonProductUrl(asin: string): string {
  return `https://www.amazon.com/dp/${encodeURIComponent(asin.trim())}`;
}

/** Walmart item pages are keyed by item id; `supply.walsku` holds that id. */
export function walmartItemUrl(itemId: string): string {
  return `https://www.walmart.com/ip/${encodeURIComponent(itemId.trim())}`;
}
